module.exports = __webpack_public_path__ + "img/cham_yes.ae0e5eda.png";